import contract from './common/contract';
import accountReceive from './account/receive';
import accountRegister from './account/register';
import personalInfo from './proceed/personalInfo';
import collections from './proceed/collections';
import loanList from './proceed/loanList';
import common from './common';
export default [
  contract,
  accountReceive,
  accountRegister,
  personalInfo,
  collections,
  loanList,
  ...common,
];



// WEBPACK FOOTER //
// ./src/models/index.js